module.exports = __webpack_public_path__ + "static/media/mmz4.8f02d49e.jpg";